import { render, staticRenderFns } from "./ParamsDocumentation.vue?vue&type=template&id=3d78711e"
import script from "./ParamsDocumentation.vue?vue&type=script&lang=ts"
export * from "./ParamsDocumentation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports